import { InviteSupportLink } from "./InviteSupportLink";

export const AlreadyAcceptedError: React.FC = () => (
  <>
    This license has already been accepted. Please email us at{" "}
    <InviteSupportLink errorCode="V702" /> if you need further assistance.
  </>
);
